import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  static targets = ["tag", "checkbox", "dropdown", "arrow", "clear", "count", "placeholder"];
  static values = {
    maxItems: Number, default: 2
  }

  connect() {
    this.update();
    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close();
    };
    document.addEventListener("click", this._outsideClick);
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick);
  }

  toggle(e) {
    e.preventDefault();
    this.dropdownTarget.classList.toggle("open");
    this.arrowTarget.classList.toggle("rotated");
  }

  update() {
    const checked = this.checkboxTargets.filter(c => c.checked);

    this.tagTargets.forEach(tag => {
      const index = checked.findIndex(c => c.value === tag.dataset.value);
      tag.hidden = index === -1 || index >= this.maxItemsValue;
    });

    this.countTarget.hidden = checked.length <= this.maxItemsValue;
    this.countTarget.textContent = `+ ${checked.length - this.maxItemsValue}`;

    this.clearTarget.hidden = checked.length === 0;
    this.placeholderTarget.hidden = checked.length > 0;
  }

  clear(e) {
      e.stopPropagation();
      this.checkboxTargets.forEach(c => c.checked = false);
      this.update();
  }

  close() {
    this.dropdownTarget.classList.remove("open");
    this.arrowTarget.classList.remove("rotated");
  }
}
